var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',[_c('BaseNavbar')],1),_c('div',{staticClass:"content-container"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }